"use client";

import React from "react";
import { MessageCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "¿Qué diferencia a NexoMayor de una agencia de cuidadoras?",
  answer: "A diferencia de una agencia tradicional que solo provee personal por horas, en NexoMayor actuamos como un 'apoderado operativo'. Nos encargamos de la gestión integral: coordinamos la salud, logística, bienestar y emergencias de tu familiar, implementando protocolos estrictos, trazabilidad y reportes constantes para tu tranquilidad."
}, {
  question: "¿Cómo funciona el proceso de evaluación inicial?",
  answer: "Comenzamos con una evaluación exhaustiva de las necesidades médicas, logísticas y emocionales del adulto mayor. Con esta información, diseñamos un Plan Personalizado de cuidado. Una vez aprobado, iniciamos la coordinación de todos los servicios requeridos y establecemos los canales de reporte con la familia."
}, {
  question: "¿Qué sucede en caso de una emergencia médica?",
  answer: "Contamos con protocolos de emergencia preestablecidos. Dependiendo del plan contratado (como nuestro Premium 24/7), tenemos capacidad de respuesta inmediata, coordinando traslados, contactando a médicos tratantes y manteniendo a la familia informada en tiempo real, actuando como representantes en el lugar si es necesario."
}, {
  question: "¿Cómo me mantienen informado sobre el estado de mi familiar?",
  answer: "La transparencia es uno de nuestros pilares. Proveemos reportes detallados y periódicos sobre la salud, estado de ánimo y actividades de tu familiar. Además, mantenemos un registro auditable de todas las gestiones realizadas, al cual puedes acceder para tener total tranquilidad."
}, {
  question: "¿Puedo contratar servicios puntuales sin un plan mensual?",
  answer: "Sí, ofrecemos nuestro 'Banco de Horas', diseñado para acompañamientos y gestiones específicas como visitas al médico, trámites, compras o traslados. Es una opción flexible para quienes necesitan apoyo puntual con la misma calidad y protocolos de nuestros planes integrales."
}];
export default function PreguntasFrecuentes() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const whatsappUrl = "https://wa.me/56934141843?text=Hola NexoMayor, tengo algunas dudas sobre sus servicios y me gustaría conversar.";
  return <section id="preguntas-frecuentes" className="w-full bg-background py-24 md:py-32">
      <div className="mx-auto max-w-[800px] px-6 md:px-8">
        
        {}
        <div ref={headerRef} className={`mb-16 text-center transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Preguntas Frecuentes
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Resolvemos tus principales dudas sobre nuestro servicio de gestión integral para personas mayores.
          </p>
        </div>

        {}
        <div ref={accordionRef} className={`transition-all duration-700 delay-200 ease-out ${isAccordionVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border py-2">
                <AccordionTrigger className="text-left text-lg font-semibold text-foreground hover:text-primary hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed text-muted-foreground pb-6 pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {}
        <div ref={ctaRef} className={`mt-20 flex flex-col items-center justify-center rounded-2xl bg-accent/50 p-8 text-center transition-all duration-700 delay-400 ease-out md:p-12 ${isCtaVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h3 className="mb-2 text-xl font-semibold text-foreground">
            ¿Aún tienes dudas?
          </h3>
          <p className="mb-8 text-muted-foreground">
            Estamos aquí para escucharte y orientarte sobre la mejor solución para tu familia.
          </p>
          <Button asChild size="lg" className="h-14 rounded-full bg-[#25D366] px-8 text-base font-bold text-white hover:bg-[#20BD5A] shadow-md hover:shadow-lg transition-all">
            <Link to={whatsappUrl} newTab>
              <MessageCircle className="mr-2 size-5" />
              Hablar por WhatsApp
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}